import axios from "axios";
import parseAppointmentData from "../../../parsers/AppointmentDataParser";

const getAppointmentById = async (baseUrl, token, doctorId, appointmentId) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId, config)
        .then((res) => {
            getResponse = {
                status: res.data.status,
                data: parseAppointmentData(res.data.data)
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return getResponse
}

export default getAppointmentById;